<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 82 100">
    <defs>
      <path id="a" d="M0 0h81.913v100H0z" />
    </defs>
    <g fill="none" fill-rule="evenodd">
      <path
        fill="#B6E7F1"
        d="M35.813 65.518c.362-.283.543-.677.543-1.182 0-.505-.177-.895-.531-1.17-.355-.276-.84-.414-1.455-.414h-2.748v3.19h2.748c.6 0 1.081-.141 1.443-.424M16.866 64.336l-1.685 4.292h3.371z"
      />
      <g>
        <path
          :fill="iconColor"
          d="M52.035 59.264h4.988l-6.258 7.39 7.413 8.675H53.12l-6.328-7.138v7.138h-4.156V59.264h4.156v6.128l5.242-6.128zm-24.57 16.065V59.264h7.205c1.816 0 3.248.466 4.295 1.4 1.062.933 1.594 2.142 1.594 3.626s-.532 2.7-1.594 3.65c-1.047.932-2.479 1.4-4.295 1.4h-3.048v5.99h-4.157zm43.742 18.153H16.07c-2.287 0-4.148-1.85-4.148-4.125v-4.77h51.401c2.383 0 4.315-1.918 4.315-4.288V54.29c0-2.37-1.932-4.29-4.315-4.29H11.922V10.644c0-2.269 1.861-4.119 4.148-4.119l37.957-.04V20.43c0 4.073 3.325 7.38 7.426 7.38l13.744-.039.154 61.586c0 2.275-1.857 4.125-4.144 4.125zM8.114 75.33l6.79-16.157h3.995l6.788 16.157h-4.456l-1.363-3.396h-6.004l-1.362 3.396H8.114zM56.481 0H16.07C10.166 0 5.36 4.78 5.36 10.643V50H4.316C1.932 50 0 51.92 0 54.289v26.01c0 2.37 1.932 4.288 4.315 4.288h1.046v4.77C5.36 95.227 10.166 100 16.07 100h55.137c5.901 0 10.707-4.773 10.707-10.643V25.19L56.48 0z"
        />
      </g>
      <path
        :fill="iconColor"
        d="M34.524 40.151c-1.42 0-2.701-.85-3.245-2.155a3.476 3.476 0 0 1 .761-3.806 3.529 3.529 0 0 1 3.829-.756 3.492 3.492 0 0 1 2.168 3.226c0 1.928-1.573 3.491-3.513 3.491"
      />
      <path
        :fill="iconColor"
        d="M41.725 34.12a2.196 2.196 0 0 1-1.24 1.15 2.212 2.212 0 0 1-1.692-.06 2.19 2.19 0 0 1-1.153-1.235 2.18 2.18 0 0 1 .061-1.686 2.19 2.19 0 0 1 1.239-1.148 2.205 2.205 0 0 1 1.691.06 2.203 2.203 0 0 1 1.094 2.92zm-10.38.001a2.22 2.22 0 0 1-2.013 1.289 2.203 2.203 0 0 1-.772-4.269 2.206 2.206 0 0 1 1.691.06c.538.245.948.683 1.154 1.235.206.551.185 1.15-.06 1.685zm20.954-11.616l-3.064-2.244-3.989 5.405a18.471 18.471 0 0 0-10.725-3.412c-3.511 0-6.796.976-9.592 2.669l-3.44-4.662-3.065 2.244 3.474 4.708c-3.57 3.324-5.803 8.037-5.803 13.256v1.895h36.852v-1.895c0-4.731-1.834-9.046-4.836-12.288l4.188-5.676z"
      />
    </g>
  </svg>
</template>

<script>
  export default {
    name: 'icon-apk',
    props: {
      width: {
        type: [Number, String],
        default: 82
      },
      height: {
        type: [Number, String],
        default: 100
      },
      iconColor: {
        type: String,
        default: 'currentColor'
      }
    }
  };
</script>
